const ECOMMERCE  = {
    "heroQuoteSection": {
        "enable": true,
        "title": "E-Commerce Web Development",
        "headline": "<strong>e-commerce solutions</strong> for your online business needs and customer retention.",
        "image": require('../images/ecom/slider-laptop.png'),
        "position": "left",
        "btnGrad" : "orange",
        "class": "move-from-left slider-left",
        "slider": {
          "type": 2,
          "images": [
            {
              "laptop": require('../images/ecom/slide1.jpg'),
              "alt": "Covet & Mane"
            },
            {
              "laptop": require('../images/ecom/slide2.jpg'),
              "alt": "Perfumania"
            },
            {
              "laptop": require('../images/ecom/slide3.jpg'),
              "alt": "1800Flowers"
            }
          ]
        }
    },
    "textWithImage":{
      "enable": true,
      "content": "Mobikasa offers a broad range of e-commerce web development services with added expertise in Shopify and Magento, design, testing, migration, support and maintenance.",
      "image": require('../images/ecom/ecomm-2.png'),
      "class": "bounce-up-down-2",
      "portfolio": {
        "icons": [
          {
            "image": require('../svgs/shopify-2.svg'),
            "url": "/shopify"
          },
          {
            "image": require('../svgs/wordpress-2.svg'),
            "url": ""
          },
          {
            "image": require('../svgs/saleforce-2.svg'),
            "url": ""
          }
        ],
        "class": "grad-orange"        
      }
    },
    "headingWithIcons":{
      "enable": true,
      "title": "We are experts in",
      "columns": 4, //value should be 4 or 6
      "icons": [
        {
          "src": require('../svgs/magento.svg'),
          "alt": "Magento"
        },
        {
          "src": require('../svgs/shopify.svg'),
          "alt": "Shopify"
        },{
          "src": require('../svgs/shopify-plus.svg'),
          "alt": "Shopify Plus"
        },
        {
          "src": require('../svgs/salesforce.svg'),
          "alt": "Salesforce"
        },
        {
          "src": require('../svgs/bigcommerce.svg'),
          "alt": "Bigcommerce"
        },
        {
          "src": require('../svgs/wordpress.svg'),
          "alt": "Wordpress"
        },
        {
          "src": require('../svgs/presta.svg'),
          "alt": "Presta"
        },
        {
          "src": require('../svgs/react.svg'),
          "alt": "React"
        }
      ]
    },
    "faq":{
      "enable": true,
      "title": "Frequently asked questions",
      "questions": [
        {
          "key": 1,
          "q": "What is E-commerce website design?",
          "a": "E-commerce web design refers to the layout and presentation of various features present within an online platform for sales, customer feedback, tracking and more. The web design element is what distinguishes different e-commerce platforms from one another in terms of aesthetics and visual appeal. Without a unique and sophisticated e-commerce web design, customer retention is nearly impossible."
        },
        {
          "key": 2,
          "q": "How to choose an E-commerce web development agency?",
          "a": `The first thing to note is that e-commerce web development is not a short-term game. It’s a long process of constant updates and maintenance by the web development experts hired. So, it’s important to remember that if you have a budget to hire well established web development agencies, that’s exactly what you should do.
          <br/><br/>
          While choosing a web development agency, it’s important to look into their previous work. Hire an agency that has already worked on e-commerce sites for your particular industry. Hiring a web agency that has experience in your field can help you as they would have already made mistakes with previous clients and learnt from them. This will help save you time and will get you to your goals faster.`
        },
        {
          "key": 3,
          "q": "How much does an e-commerce web design service cost?",
          "a": `<p>Well, the costs vary from agency to agency. The bigger the firm, the higher the cost. However, there are certain factors that come into play here. They have been listed below for your reference.</p>
          <br />
          <ul class="default">
          <li>Design</li>
          <li>Functionality</li>
          <li>Marketing and SEO</li>
          <li>Integration</li>
          <li>Company Selection</li>
          <li>Programming</li>
          </ul><br />
          <p>Depending upon the size and complexities, these web design services can cost anywhere between $20,000 and $ 210,000 if you really go all out.</p>`
        }
      ]
    }
  };

  export default ECOMMERCE;